document.addEventListener("latte:init", init);
function init() {

    var winWidth = $(window).width();

    if (winWidth > 1024) {
        people = $('.teacher-block').length / 2;

        if (people <= 5) {
            rows = 2;
            slidesToShow = 2;
        } else {
            rows = 2;
            slidesToShow = 3;
        }
    } else {
        rows = 1;
        slidesToShow = 3;
    }

    $('.faculty-slider').slick({
        dots: false,
        speed: 450,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        rows: rows,
        cssEase: 'ease-in-out',
        centerPadding: '0',
        infinite: false,
        lazyLoad: 'ondemand',
        prevArrow: '<button class="slick-prev js-slick" alt="Previous Slide"></button>',
        nextArrow: '<button class="slick-next js-slick" alt="Next Slide"></button>',
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    asNavFor: '.faculty-expanded-slider',
                    centerMode: true,
                    infinite: true,
                    slidesToShow: slidesToShow,
                    swipe: true
                }
            }
        ]
    });

    $('.faculty-expanded-slider').slick({
        dots: false,
        speed: 450,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'ease-in-out',
        centerPadding: '0',
        infinite: false,
        lazyLoad: 'ondemand',
        prevArrow: '<button class="slick-prev" alt="Previous Slide"></button>',
        nextArrow: '<button class="slick-next" alt="Next Slide"></button>',
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    arrows: false,
                    swipe: false,
                    adaptiveHeight: true
                }
            }
        ]
    });

    $('.tabs').find('li:first-of-type').addClass('active');

    $('.tabs').find('li').click(function (e) {
        $(this).parent().find('li').removeClass('active');
        $(this).addClass('active');
        tab = $(this).find('a').attr('data-tab');
        $(this).parent().parent().find('div').css({ "display": "none" });
        $('.tabs').find('div#tabs-' + tab).css({ "display": "block" });
        e.preventDefault();
    });

    $('.slick-arrow').click(function(e) {
        $('.tabs').each(function() {
            $(this).find('li')[1].removeClass('active');
            $(this).find('li')[0].addClass('active');
        });
        $('.tabs').find('div#tabs-1').css({ "display": "block" });
        $('.tabs').find('div#tabs-2').css({ "display": "none" });
    });

    $('.remodal-close').click(function (e) {
        sliceIndex = $(this).attr('data-slice-index');
        $('.js-expanded-' + sliceIndex).removeClass('visible');
        $('.js-slick').removeClass('hide');
        $('.faculty-expanded-slider').slick('resize');
        e.preventDefault();
    });

    $('.faculty-slider').find('.teacher-block').click(function (e) {
        slideId = $(this).attr('data-id');
        sliceIndex = $(this).attr('data-slice-index');
        $('.js-expanded-' + sliceIndex).addClass('visible');
        $('.js-slick').addClass('hide');
        $('.js-expanded-' + sliceIndex).slick('slickGoTo', slideId, true);
    });
}



//////////////////
// WEBPACK FOOTER
// ./public/js/faculty.js
// module id = 72
// module chunks = 0